/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyUploadIcon = createIcon("EmptyUploadIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M36.006 95A2.01 2.01 0 0134 92.997V33.003A2 2 0 0135.998 31h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2.001 2.001 0 0177.994 95H36.006Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.006 89A2.01 2.01 0 0140 86.997V27.003A2 2 0 0141.998 25h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2.002 2.002 0 0183.994 89H42.006Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 74.25v-22.5m10.5 10.5L63 51.75l-10.5 10.5",
    stroke: "#665AF4",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 41H70V26l15 15Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.994 89A2 2 0 0086 87.003V41.001c0-.553-.313-1.314-.703-1.704L71.703 25.703c-.388-.388-1.141-.703-1.7-.703H41.999A2.006 2.006 0 0040 27.003v59.994c0 1.106.898 2.003 2.006 2.003h41.988Zm-.99-2H42.996a.997.997 0 01-.997-.991V27.99c0-.547.447-.991.995-.991h26.06l-.048 13.008A1.984 1.984 0 0070.992 42H84v43.997A.998.998 0 0183.003 87ZM72.001 40A1.007 1.007 0 0171 38.998v-9.995c0-.547.316-.687.706-.297l10.588 10.588c.385.385.257.706-.296.706h-9.996Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyUploadIcon"
});